import { BlockchainsMoleculeReatom } from "@/app/blockchains/blockchain-molecule.reatom"
import type { Blockchain } from "@anaconda/core/blockchain/types"
import { action, atom, computed } from "@reatom/core"
import { molecule } from "bunshi"

export type SearchBlockchainFilter = Blockchain | "ALL"

export const CollectionSearchBlockchainMoleculeReatom = molecule((mol) => {
  const { supportedBlockchains, blockchainsMap } = mol(
    BlockchainsMoleculeReatom,
  )

  const selectedBlockchain = atom<SearchBlockchainFilter>(
    "ALL",
    "searchSelectedBlockchain",
  )

  const blockchainsQueryFilter = computed(() => {
    const selected = selectedBlockchain()

    if (!selected || selected === "ALL") {
      return [...supportedBlockchains()]
    }
    return [selected]
  }, "searchBlockchainsQueryFilter")

  const setSelectedBlockchain = action(
    (newBlockchain: SearchBlockchainFilter) => {
      if (newBlockchain === selectedBlockchain()) return
      selectedBlockchain.set(newBlockchain)
    },
    "setSearchSelectedBlockchain",
  )

  const availableBlockchains = computed(() => {
    const supported = supportedBlockchains()
    return ["ALL" as const, ...supported] as SearchBlockchainFilter[]
  }, "searchAvailableBlockchains")

  return {
    selectedBlockchain,
    availableBlockchains,
    blockchainsQueryFilter,
    setSelectedBlockchain,
    blockchainsMap,
  }
})
